<template>
    <tr class="document-allocations">
        <td class="left-border" :colspan="multiple_contractors ? 12 : 11">
            {{ __('date') }}: <strong>{{ allocation.date }}</strong> |
            <span class="text-capitalize">{{ __('type') }}</span>: <strong>{{ allocation.type }}</strong> |
            {{ __('No') }}: <strong>{{ allocation.document_number }}</strong> |
            {{ __('contractor') }}:
            <strong><truncated-text :text="allocation.contractor" :max_length="100"/></strong> |
            {{ __('gross_amount') }}: <strong>{{ allocation.gross_amount  }}</strong> |
            {{ __('currency') }}: <strong>{{ allocation.currency }}</strong> |
            {{ __('allocated') }}: <strong>{{ allocation.allocated }}</strong> |
            {{ __('currency') }}: <strong>{{ allocation.allocated_currency }}</strong>
        </td>
        <td class="text-right table-icons">
            <a v-show="controls.includes('destroy')"
               @click="destroy(allocation)"
               :title="__('delete_connection')"
               class="icon-delete" data-toggle="tooltip" data-placement="top">
                <i class="fa fa-trash"></i></a>

            <a v-show="controls.includes('history')"
               :href="allocation.history_url"
               :title="__('goto_contractor_history')"
               :data-original-title="__('goto_contractor_history')"
               data-toggle="tooltip" data-placement="top">
                <i class="fas fa-share"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import hasTooltips from './../../../mixins/hasTooltips.js'

    export default {
        name: "DocumentAllocationsDetailsRow",
        mixins: [hasTooltips],
        methods: {
            destroy: function(allocation) {
                var self = this;
                swal({
                        title: $.i18n._("delete_allocation_?"),
                        text: $.i18n._('it_will_not_be_possible_to_retrieve_it_later_!'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d9534f",
                        confirmButtonText: $.i18n._("delete"),
                        cancelButtonText: $.i18n._("cancel"),
                        closeOnConfirm: true
                    },
                    function (result) {
                        if(result) {
                            self.$emit('destroy', allocation);
                        }
                    }
                );
            },
        },
        props: {
            allocation: {
                type: Object,
                required: true
            },
            controls: {
                type: Array,
                required: false,
                default: () => ['destroy']
            },
            multiple_contractors: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
